export const RE_OCCURING_INVOICE_LIST = "re_occuring_invoice_list";
export const RE_OCCURING_INVOICE_LIST_SUCCESSFULL = "re_occuring_invoice_list_successfull";
export const CREATE_RE_OCCURING_INVOICE='create_re_occuring_invoice';
export const CREATE_RE_OCCURING_INVOICE_SUCCESSFULL='create_re_occuring_invoice_successfull';



